(() => {
  const ROOT_SELECTOR = '[data-hgb-category-shop]';
  const PANEL_SELECTOR = '[data-hgb-category-panel]';

  const createNextButton = (carousel, rail) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hgb-category-shop__next';
    button.dataset.hgbCategoryNext = '';
    button.setAttribute('aria-label', 'Ver más productos');

    if (rail.id) {
      button.setAttribute('aria-controls', rail.id);
    }

    button.innerHTML = `
      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
        <path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/>
      </svg>
    `;

    carousel.appendChild(button);
    return button;
  };

  const getScrollStep = (rail) => {
    const card = rail.querySelector('.hgb-category-card');
    if (!card) return Math.max(rail.clientWidth * 0.8, 280);

    const styles = window.getComputedStyle(rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const setupPanel = (panel) => {
    const carousel = panel.querySelector('[data-hgb-category-carousel]');
    const rail = panel.querySelector('[data-hgb-category-rail]');
    if (!carousel || !rail) return;

    let nextButton = carousel.querySelector('[data-hgb-category-next]');
    if (!nextButton) {
      nextButton = createNextButton(carousel, rail);
    }

    const updateControls = () => {
      const maxScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
      const hasOverflow = maxScroll > 4;
      const atEnd = !hasOverflow || rail.scrollLeft >= maxScroll - 4;

      nextButton.hidden = !hasOverflow;
      nextButton.disabled = atEnd;
      nextButton.setAttribute('aria-disabled', String(atEnd));
    };

    panel.__hgbCategoryUpdateControls = updateControls;

    if (nextButton.dataset.hgbCategoryBound !== 'true') {
      nextButton.dataset.hgbCategoryBound = 'true';
      nextButton.addEventListener('click', () => {
        rail.scrollBy({
          left: getScrollStep(rail),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }

    if (rail.dataset.hgbCategoryCarouselBound !== 'true') {
      rail.dataset.hgbCategoryCarouselBound = 'true';

      let scrollFrame = null;
      rail.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          updateControls();
        });
      }, { passive: true });
    }

    if (!panel.__hgbCategoryResizeObserver && 'ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => updateControls());
      resizeObserver.observe(rail);
      panel.__hgbCategoryResizeObserver = resizeObserver;
    }

    window.requestAnimationFrame(updateControls);
  };

  const updateVisiblePanel = (root) => {
    root.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      if (!panel.hidden && typeof panel.__hgbCategoryUpdateControls === 'function') {
        window.requestAnimationFrame(panel.__hgbCategoryUpdateControls);
      }
    });
  };

  const setupRoot = (root) => {
    root.querySelectorAll(PANEL_SELECTOR).forEach(setupPanel);

    if (!root.__hgbCategoryPanelObserver) {
      const observer = new MutationObserver((mutations) => {
        const panelChanged = mutations.some(
          (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'hidden'
        );

        if (panelChanged) updateVisiblePanel(root);
      });

      observer.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });

      root.__hgbCategoryPanelObserver = observer;
    }

    updateVisiblePanel(root);
  };

  const init = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(setupRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
